import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Toast } from '../shared';

@Injectable({
  providedIn: 'root'
})

export class AlertService {

  private toasts: Toast[] = [];
  private subToast: Subject<Toast[]> = new Subject<Toast[]>();
  private modals: any[] = [];         // list of modals dialog divs displayed in application (splashscreen & alert dialog)

  constructor() { }


  // #region INIT MODAL DIALOGS IMPLEMENTATION

  // called on the init event of any modal dialog (/layout/components/dialog.component.ts)
  addModalDialog(modal: any): void {
    this.modals.push(modal);
  }
  // called on the destroy event of any modal dialog (/layout/components/dialog.component.ts)
  removeModalDialog(id: string): void {
    const modalToRemove: any = this.findWhere(this.modals, id);
    this.modals = this.without(this.modals, [modalToRemove]);
  }
  // display the modal dialog specified by the id parameter
  openModal(id: string): void {
    const modal: any = this.findWhere(this.modals, id);
    if (modal) {
      modal.open();
    }
  }
  // hide the modal dialog specified by the id parameter
  closeModal(id: string): void {
    const modal: any = this.findWhere(this.modals, id);
    if (modal) {
      modal.close();
    }
  }

  // #endregion


  // #region SPLASHSCREEN / ALERT

  // show/hide splashscreen
  showSplash(show: boolean): void {
    if (show) {
      this.openModal('splashscreen');
    } else {
      this.closeModal('splashscreen');
    }
  }

  // show alert message
  showAlert(message: string, titlealert?: string, type?: string): void {
    titlealert = !titlealert ? '' : titlealert;
    type = !type ? '' : type;
    const modal: any = this.findWhere(this.modals, 'commonalert');
    if (modal) {
      modal.openMessage(message, 'pTarget', titlealert, type);
    }
  }

  // #endregion


  // #region TOAST IMPLEMENTATION

  getToasts(): Observable<Toast[]> {
    return this.subToast.asObservable();
  }

  removeToast(toast: Toast): void {
    this.toasts = this.toasts.filter((item: Toast): boolean => item.id !== toast.id);
    this.subToast.next(this.toasts);
  }

  showInfoToast(msg: string): void {
    const toast: Toast = new Toast();
    toast.id = this.generateId();
    toast.title = msg;
    toast.faIcon = 'fa-info';
    toast.closeAuto = true;
    toast.timeout = 3000;
    toast.color = '#03A9F4';
    this.addToast(toast);
  }

  showWarningToast(msg: string): void {
    const toast: Toast = new Toast();
    toast.id = this.generateId();
    toast.title = msg;
    toast.faIcon = 'fa-exclamation';
    toast.closeAuto = true;
    toast.timeout = 10000;
    toast.color = '#FF9800';
    this.addToast(toast);
  }

  showAlertToast(msg: string): void {
    const toast: Toast = new Toast();
    toast.id = this.generateId();
    toast.title = msg;
    toast.faIcon = 'fa-exclamation-triangle';
    toast.closeAuto = true;
    toast.timeout = 10000;
    toast.color = '#f44336';
    this.addToast(toast);
  }

  showSuccessToast(msg: string): void {
    const toast: Toast = new Toast();
    toast.id = this.generateId();
    toast.title = msg;
    toast.faIcon = 'fa-check';
    toast.closeAuto = true;
    toast.timeout = 3000;
    toast.color = '#8BC34A';
    this.addToast(toast);
  }

  // #endregion


  // #region PRIVATE FUNCTIONS

  // Generate a generic ID
  private generateId(): string {
    return Math.random()
      .toString(36)
      .substr(2, 9);
  }
  // add toast to toasts and create a timeout to delete him
  private addToast(toast: Toast): void {
    this.toasts = [toast, ...this.toasts];
    this.subToast.next(this.toasts);
    if (toast.closeAuto) {
      setTimeout((): void => this.removeToast(toast), toast.timeout);
    }
    if (this.toasts.length > 5) {
      this.removeToast(this.toasts[this.toasts.length - 1]);
    }
  }

  private without(array: any, [propertyToRemove]: any): any {
    const array2: any = array;
    for (let i: number = 0; i < array.length; i++) {
      for (let j: number = 0; j < propertyToRemove.length; j++) {
        if (array[i] === propertyToRemove[j]) {
          array2.splice(i, 1);
        }
      }
    }
    return array2;
  }

  private findWhere(array: any, objet: string): any {
    let modal: any;
    for (let i: number = 0; i < array.length; i++) {
      if (array[i].id === objet) {
        modal = array[i];
        break;
      }
    }
    return modal;
  }

  // #endregion
}
